
































import Vue, { PropType } from 'vue';
import { uniqueId } from 'lodash';
import FileUploadOutline from '@/assets/file-upload-outline.svg';
import FileOutline from '@/assets/file-outline.svg';
import { isFileTypeCompatible } from '@/utils/is-file-type-compatible';

const INPUT_ID_PREFIX = 'uploader-input-';

interface Data {
  isHoveredByDragging: boolean;
}

export default Vue.extend({
  name: 'AUploader',
  components: {
    FileUploadOutline,
    FileOutline,
  },
  props: {
    value: { type: [File, Array] as PropType<File | File[] | null>, default: null },
    accept: { type: String, default: '' },
    disabled: Boolean,
  },
  data(): Data {
    return {
      isHoveredByDragging: false,
    };
  },
  computed: {
    id(): string {
      return uniqueId(INPUT_ID_PREFIX);
    },
    isMultiple(): boolean {
      return Array.isArray(this.value);
    },
    fileNames(): string {
      return this.isMultiple
        ? (this.value as File[]).reduce(
          (acc, file, index, arr) => `${acc}${file.name}${index === arr.length - 1 ? '' : ', '}`,
          '',
        )
        : (this.value as File | null)?.name ?? '';
    },
    iconComponent(): typeof FileOutline | typeof FileUploadOutline {
      return this.fileNames ? FileOutline : FileUploadOutline;
    },
  },
  methods: {
    onDragenter(evt: DragEvent): void {
      if (evt.dataTransfer?.types.every((type) => type === 'Files')) {
        this.isHoveredByDragging = true;
      }
    },
    onDragleave(evt: DragEvent): void {
      if (!this.$el.contains(evt.relatedTarget as Node)) {
        this.isHoveredByDragging = false;
      }
    },
    onInput(evt: InputEvent): void {
      this.isHoveredByDragging = false;

      const files = (evt.target as HTMLInputElement | null)?.files;

      if (!files?.length) {
        this.$emit('input', this.isMultiple ? [] : null);
        return;
      }

      const compatibleFiles = Array.from(files).filter((file) => isFileTypeCompatible(file, this.accept));

      if (compatibleFiles.length) {
        this.$emit('input', this.isMultiple ? compatibleFiles : compatibleFiles[0]);
      }
    },
  },
});
